import { postRequest } from '../../API'
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
/*********************************************************
* Function Name : list
* Description   : Get list of due users 
* By            : Afsar Ali
* Date          : 18-06-2025
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}./crm/customer/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addeditdata
* Description   : Get list of add/edit data 
* By            : Afsar Ali
* Date          : 28-11-2024 
*********************************************************/
export const collectAmount = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}./crm/customer/collect-due`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addeditdata
* Description   : Get list of add/edit data 
* By            : Afsar Ali
* Date          : 28-11-2024 
*********************************************************/
export const settleAmount = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}./crm/customer/settle-due`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addeditdata
* Description   : Get list of add/edit data 
* By            : Afsar Ali
* Date          : 28-11-2024 
*********************************************************/
export const updateCollection = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}./crm/customer/update-collection`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function